
    // redirect to groovemaster.xyz
    if (import.meta.env.PROD) {
      if (window.location.hostname != 'groovemaster.xyz') {
        window.location.href = 'https://groovemaster.xyz' + window.location.pathname
      }
    }
  